module.exports = __webpack_public_path__ + "static/img/refricola.202762a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/refricola.png
// module id = fMYl
// module chunks = 0